import { render, staticRenderFns } from "./AddTag.vue?vue&type=template&id=21648464"
import script from "./AddTag.vue?vue&type=script&lang=js"
export * from "./AddTag.vue?vue&type=script&lang=js"
import style0 from "./AddTag.vue?vue&type=style&index=0&id=21648464&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports